import {
  Box,
  Button,
  NavBarWrapper,
  NavBarSection,
  NavBarItem,
  ProgressBar
} from 'src/viewLayer/components/DesignSystem';

import { t } from 'src/viewLayer/helpers/translations';
import { getIndexPageURL, SIGN_IN_URL, DASHBOARD_URL } from 'src/dataLayer/env';
import { getAutoLoginReturnToUrl } from 'src/viewLayer/components/nodes/RedirectNode/redirectNodeHelpers';
import { getValidatedQueryStringFromParams } from 'src/dataLayer/localData/queryParams';
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream';
import type { NavbarProps } from './types';
import './index.scss';

const LoginButton = ({ learnLang }: { learnLang: string }): JSX.Element => {
  const validatedQueryParams = getValidatedQueryStringFromParams(
    window.location.search, learnLang
  );
  const loginUrl = `${SIGN_IN_URL}${validatedQueryParams}`;

  return (
    <Button
      as="a"
      color="secondary"
      data-testid="login-button"
      href={loginUrl}
      id="uat-login-button"
      className="loginButton"
      onClick={(): void => trackGuiInteracted({ learnLang, guiElementName: 'login' })}
      size="micro"
      fullWidth={false}
    >
      {t('common.navigation.button.login')}
    </Button>
  );
};

export const Navbar = ({
  hideLoginButton,
  showProgressBar,
  progressData,
  learnLang,
  signinToken
}: NavbarProps): JSX.Element => {
  const { currentFlowStep = 0, flowLength = 0 } = progressData || {};
  let autoLoginURL;
  if (signinToken) {
    autoLoginURL = getAutoLoginReturnToUrl({
      nodeConfig: undefined,
      learnLang,
      queryParams: { return_to: DASHBOARD_URL },
      signinToken
    });
  }

  const optionalSections: {
    centerSection?: JSX.Element;
    rightAlignedItems?: JSX.Element;
  } = {};

  if (showProgressBar) {
    optionalSections.centerSection = (
      <Box className="ProgressBarContainer">
        <ProgressBar
          currentItem={currentFlowStep}
          currentItemProgress={1}
          fullWidth
          itemsCount={flowLength}
          displayCounter={false}
          overallProgress={1}
        />
      </Box>
    );
  }
  if (!hideLoginButton) {
    optionalSections.rightAlignedItems = (
      <NavBarSection>
        <NavBarItem>
          <LoginButton learnLang={learnLang} />
        </NavBarItem>
      </NavBarSection>
    );
  }

  return (
    <NavBarWrapper
      fullWidthSection
      hasMobileMenu={false}
      logoUrl={autoLoginURL || getIndexPageURL()}
      onLogoClick={(): void =>
        trackGuiInteracted({ learnLang, guiElementName: 'babbel-logo' })
      }
      {...optionalSections}
    />
  );
};
